import React from 'react';
import { Tag } from '@chakra-ui/react';
import { getPaymentLinkStatusColor } from '../models/payment-link-view';

export interface PaymentLinkViewStatusBadgeProps {
  status: string;
  fontSize?: string;
}

// `status` ya viene en español directo del BFF ("Pendiente", "Aprobado", "Cancelado"),
// así que se muestra tal cual — solo el color se resuelve por catálogo.
export const PaymentLinkViewStatusBadge = ({ status, fontSize = 's' }: PaymentLinkViewStatusBadgeProps) => {
  const config = getPaymentLinkStatusColor(status);

  return (
    <Tag
      size="s"
      textTransform="capitalize"
      background={config.background}
      color={config.color}
      borderColor={config.borderColor}
      borderRadius="full"
      paddingY="s"
      paddingX="xl"
      borderWidth="normal"
      fontSize={fontSize}
    >
      {status}
    </Tag>
  );
};
